import { render, staticRenderFns } from "./StockCardDetail.vue?vue&type=template&id=f3411f70&scoped=true&"
import script from "./StockCardDetail.vue?vue&type=script&lang=js&"
export * from "./StockCardDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3411f70",
  null
  
)

export default component.exports